// System Post Types and Metadata Definitions

export enum IPostType {
  USER_POST = 'USER_POST', // Regular user post
  SELECTION_ITEM_POST = 'SELECTION_ITEM_POST', // Links to selection item
  SCHEDULE_ITEM_POST = 'SCHEDULE_ITEM_POST', // Links to schedule item
  FILE_COMMENT = 'FILE_COMMENT', // Links to document view
}

// Base interface for all system post metadata
interface IBaseSystemMetadata {
  secondaryText: string; // Additional information displayed in the UI
}

// Type-specific metadata using discriminated unions
export interface ISelectionItemMetadata extends IBaseSystemMetadata {
  type: 'SELECTION_ITEM_POST';
  linkData: {
    selectionId: string;
    selectionItemId: string;
    selectionName: string;
    itemValue?: string;
  };
}

export interface IScheduleItemMetadata extends IBaseSystemMetadata {
  type: 'SCHEDULE_ITEM_POST';
  linkData: {
    scheduleId: string;
    scheduleItemId: string;
    scheduleName: string;
    itemValue?: string;
  };
}

export interface IFileCommentMetadata extends IBaseSystemMetadata {
  type: 'FILE_COMMENT';
  linkData: {
    fileId: string;
    documentId: string;
    fileName: string;
    pageNumber?: number;
    commentId?: string;
  };
}

// Union type for all system metadata
export type ISystemPostMetadata =
  | ISelectionItemMetadata
  | IScheduleItemMetadata
  | IFileCommentMetadata;
